/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Loading } from 'carbon-components-react';
import React, { Suspense } from 'react';

import InstanceLoader from '@ibm-watson/shared/modules/ia/pages/instance/InstanceLoader';

/**
 * This component handles the top-level route that starts with
 * "/instance/<INSTANCE_CRN>" for Classic IA.
 *
 * For now all it does it trigger the loading of instance information
 * and, when loaded, render the Classic IA-specific routes (loaded lazily).
 */

const InstanceRoutesClassicIa = React.lazy(
  () => import('./InstanceRoutesClassicIa')
);

const InstanceRoutesNewIa = React.lazy(
  () =>
    import('@ibm-watson/shared/modules/ia/pages/instance/InstanceRoutesNewIa')
);

const InstanceRoute: React.FC = () => {
  return (
    <Suspense fallback={<Loading data-testid="loading" />}>
      <InstanceLoader
        InstanceRoutesClassicIa={InstanceRoutesClassicIa}
        InstanceRoutesNewIa={InstanceRoutesNewIa}
      />
    </Suspense>
  );
};

export default InstanceRoute;
